<template>
  <content-panel>
    <table-panel ref="tablePanel">
      <template v-slot:header-left>
        <span>质检审核配置</span>
      </template>
      <el-table stripe border ref="tableRef" :header-cell-style="{ backgroundColor: '#F4F8FB' }" highlight-current-row
        :data="tableData" :height="maxTableHeight + 42" v-if="tableReload" v-loading="loading">
        <el-table-column prop="itemName" label="配置项" min-width="150"></el-table-column>
        <el-table-column prop="content" label="配置内容" min-width="500"></el-table-column>
        <el-table-column prop="updateUser" label="更新人" min-width="80"></el-table-column>
        <el-table-column prop="creationDate" label="更新时间" min-width="160"></el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleEdit(row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </table-panel>
    <editDialog :visible.sync="isShowEdit" v-if="isShowEdit" :rowData="rowData" @success="onSearch" />
  </content-panel>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin';
import editDialog from './components/edit';
import axios from '@/utils/axiosInstance';

export default {
  name: 'QualityAuditConfig',
  mixins: [tableMixin, pagePathMixin],
  components: {
    editDialog,
  },
  data() {
    return {
      loading: false,
      tableData: [],
      tableReload: true,
      isShowEdit: false,
      searchFormData: [],
      rowData: {},
      searchForm: {},
    };
  },
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },
    async init() {
      this.loading = true;
      this.$q.qualityTestingManage
        .qualityAuditConfigPage()
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleEdit(row) {
      this.rowData = row ? JSON.parse(JSON.stringify(row)) : {};
      this.$nextTick(() => {
        this.isShowEdit = true;
      });
    },
  },

  mounted() {
    this.onSearch();
  },
};
</script>

<style lang="stylus" scoped>
.search-box {
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input {
    width: 240px !important;
  }
}

>>> .date-range .single-date {
  width: 110px !important;
}

>>> .form-number-input .el-input-number {
  width: 105px !important;
}

>>> .form-number-input .el-input-number .el-input {
  width: 105px !important;
}
</style>
